<script lang="ts">
  import type { Snippet } from "svelte"
  import { newNotification } from "@kontextwerk/web-sdk/core/overlay/notifications"
  import { mdiCalendarCheckOutline } from "@mdi/js"
  import StepActionCTA from "../../../../../../../../../../../../../../_shared/_modules/step-action-cta"
  import type {
    ConfirmAppointmentsActionPhase,
    ConfirmAppointmentsActionResult,
    ConfirmAppointmentsIntent,
    ConfirmAppointmentsOperations,
  } from "../../actions/confirmAppointments"

  type Props = {
    children?: Snippet<[Snippet]>
    intent: ConfirmAppointmentsIntent
    operations: ConfirmAppointmentsOperations
    onSubmissionResult: (result: ConfirmAppointmentsActionResult) => Promise<void> | void
    onPhaseChange?: (phase: ConfirmAppointmentsActionPhase) => void
  }

  const {
    children = null,
    intent,
    operations,
    onSubmissionResult,
    onPhaseChange = () => {},
  }: Props = $props()

  let pending = $state(false)

  const run = async () => {
    if (pending) return

    if (intent.kind === "blocked") {
      newNotification({ class: "error", html: intent.message })

      return
    }

    pending = true
    onPhaseChange("confirming")
    try {
      const response = await operations.confirm(intent.items)
      try {
        await onSubmissionResult({
          kind: "committed",
          output: { rows: intent.rows, items: response.items },
        })
      } catch (error) {
        console.error("confirm_appointments_completion_failed", error)
        newNotification({
          class: "error",
          html: "Änderung gespeichert, Oberfläche konnte nicht aktualisiert werden.",
        })
      }
    } catch (error) {
      console.error("confirm_appointments_bulk_failed", error)
      newNotification({ class: "error", html: "Termine konnten nicht bestätigt werden." })
    } finally {
      pending = false
      onPhaseChange("idle")
    }
  }
</script>

{#snippet primaryAction()}
  <StepActionCTA
    type="primaryButton"
    icon={mdiCalendarCheckOutline}
    content={pending ? "Wird bestätigt..." : intent.label}
    disabled={pending || intent.disabled}
    disabledReason={pending ? "Termine werden gerade bestätigt." : intent.disabledReason}
    onClick={run}
  />
{/snippet}

{#if children}
  {@render children(primaryAction)}
{:else}
  {@render primaryAction()}
{/if}
